module.exports = __webpack_public_path__ + "img/sys.159088b4.png";